import { type ReactElement, type ReactNode, useState } from "react"
import { RootState } from "src/app/store";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "src/features/authentication/hooks/userAuth";
import { AppDispatch } from "src/app/store";
import dsxImage from "../assests/images/dsx.png";

export interface SidebarProps {
        sideBarSelected: string,
        children?: ReactNode
}

export default function Sidebar(props: SidebarProps): ReactElement {
        const [selected] = useState<string>(props.sideBarSelected);
        const dispatch = useDispatch<AppDispatch>();
        const { authUser, isAuthenticated } = useSelector((state: RootState) => state.auth);

        const logout = async () => {
                dispatch(logoutUser(authUser));
        }

        return <>
                <div className="bg-blue-700 flex flex-col h-full justify-between text-white py-6 px-3">
                        <div className="flex flex-col gap-4">
                                <div className="flex justify-center">
                                        <Link to="/dashboard" className="flex">
                                                <img className="max-w-12 object-contain" src={dsxImage} alt="" />
                                        </Link>
                                </div>
                                {selected === "Dashboard" ?
                                        <Link to="/dashboard" className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" >
                                                Dashboard
                                        </Link>
                                        :
                                        <Link to="/dashboard" className="flex w-full justify-start px-3 py-1 cursor-pointer" >
                                                Dashboard
                                        </Link>
                                }

                                {authUser?.DealerId === 1 ?
                                        <>
                                                {selected === "Dealers" ?
                                                        <Link to="/dealers" className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" >
                                                                Dealers
                                                        </Link>
                                                        :
                                                        <Link to="/dealers" className="flex w-full justify-start px-3 py-1 cursor-pointer" >
                                                                Dealers
                                                        </Link>
                                                }
                                        </>
                                        : <></>
                                }
                                {selected === "EndUsers" ?
                                        <Link to="/endUsers" state={{ dealerID: authUser?.DealerId }} className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" >
                                                EndUsers
                                        </Link>
                                        :
                                        <Link to="/endUsers" state={{ dealerID: authUser?.DealerId }} className="flex w-full justify-start px-3 py-1 cursor-pointer" >
                                                EndUsers
                                        </Link>
                                }
                                {/* {selected === "Search" ? */}
                                {/*         <Link to="/search" className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" > */}
                                {/*                 Search */}
                                {/*         </Link> */}
                                {/*         : */}
                                {/*         <Link to="/search" className="flex w-full justify-start px-3 py-1 cursor-pointer" > */}
                                {/*                 Search */}
                                {/*         </Link> */}
                                {/* } */}
                        </div>
                        <div className="flex flex-col gap-4">
                                {selected === "UserManagement" ?
                                        <Link to="/users" className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" >
                                                UserManagement
                                        </Link>
                                        :
                                        <Link to="/users" className="flex w-full justify-start px-3 py-1 cursor-pointer" >
                                                UserManagement
                                        </Link>
                                }

                                {selected === "OrderManagement" ?
                                        <Link to="/orders" className="flex w-full justify-start bg-orange-700 rounded-md px-3 py-1 cursor-pointer" >
                                                OrderManagement
                                        </Link>
                                        :
                                        <Link to="/orders" className="flex w-full justify-start px-3 py-1 cursor-pointer" >
                                                OrderManagement
                                        </Link>
                                }

                                {selected === "Logout" ?
                                        <div className="flex justify-start w-full bg-orange-700 rounded-md px-3 py-1 cursor-pointer" onClick={logout}>
                                                Logout
                                        </div>
                                        :
                                        <div className="flex justify-start w-full rounded-md px-3 py-1 cursor-pointer" onClick={logout}>
                                                Logout
                                        </div>
                                }
                        </div>
                </div>
        </>
}
